import { Grid } from "@mui/material";
import { fDate } from "../../../utils/formatTime";
import { decrypt } from "../../../utils/encryptDecrypt";

const Declaration = (_props) => {
  const { candidateData, className } = _props
  return (
    <fieldset className={`${className}--fieldset`}>
      <legend className={`${className}--legend`}>
        Declaration{" "}
      </legend>
      <Grid container spacing={1}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          {/* <Stack direction="row" alignItems="start"> */}
          {/* <FormControlLabel
                            control={<Checkbox />}
                            name="declare_one"
                            value={declareValue?.first}
                            onChange={(e) => {
                              setDeclareValue((prev) => ({
                                ...prev,
                                first: !declareValue.first,
                              }));
                            }}
                            // label="I hereby declare that I have carefully read all the eligibility conditions mentioned in the advertisement and the above mentioned information in this application form. I accept and complete those requirements."
                            className="personal-information--checkbox"
                          />
                          <Stack direction="column" spacing={2}>
                            
                          </Stack>
                        </Stack> */}
          <p className={`${className}--subText custom-rht`}>
            1.{" I "}
            {candidateData?.name
              ? decrypt(candidateData?.name)
              : "-"}{" "}
            hereby declare that I have carefully read all the
            eligibility conditions mentioned in the advertisement
            and the above mentioned information in this
            application form. I accept and complete those
            requirements. <br /> एतद्द्वारा घोषणा करता हूं कि
            मैंने विज्ञापन में उल्लिखित पात्रता की सभी शर्तों और
            इस आवेदन पत्र में दी गई उपरोक्त जानकारी को
            सावधानीपूर्वक पढ़ लिया है। मैं उन आवश्यकताओं को
            स्वीकार करता हूं और उन्हें पूरा करता हूं।
          </p>
          {/* {errors?.declare_one && touched?.declare_one && (
                            <p className="text-danger">{errors?.declare_one}</p>
                          )} */}
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          {/* <Stack direction="row" alignItems="start">
                          <FormControlLabel
                            control={<Checkbox />}
                            name="declare_two"
                            value={declareValue?.second}
                            onChange={(e) => {
                              setDeclareValue((prev) => ({
                                ...prev,
                                second: !declareValue.second,
                              }));
                            }}
                            // label="I hereby declare that I have carefully read all the eligibility conditions mentioned in the advertisement and the above mentioned information in this application form. I accept and complete those requirements."
                            className="personal-information--checkbox"
                          />
                          <Stack direction="column" spacing={2}>
                           
                          </Stack>
                        </Stack> */}
          <p className={`${className}--subText`}>
            2.{" "}
            {/* {candidateData?.name
                            ? decrypt(candidateData?.name)
                            : "-"}{" "} */}
            I also declare that all the details / information
            given in this application form is true and correct and
            I have not hidden any facts in these particulars /
            information. If any details / information is found to
            be false or incorrect or if any facts are hidden by
            me, then my candidature should be cancelled. If such
            situation comes to light after the appointment, then
            my services should be terminated. <br />
            यह भी घोषणा करता हूं कि इस आवेदन पत्र में दिए गए सभी
            विवरण/सूचनाएं सत्य और सही हैं और मैंने इन
            विवरणों/जानकारी में कोई तथ्य नहीं छिपाया है। यदि मेरे
            द्वारा कोई विवरण/सूचना असत्य या असत्य पायी जाती है या
            कोई तथ्य छुपाया जाता है तो मेरी उम्मीदवारी रद्द कर दी
            जाये। अगर नियुक्ति के बाद ऐसी स्थिति सामने आती है तो
            मेरी सेवाएं समाप्त कर दी जानी चाहिए।
          </p>
        </Grid>
        {Number(candidateData?.is_employed) === 1 &&
          candidateData?.employee_organization_type !==
          "Others" && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {/* <Stack direction="row" alignItems="start">
                          <FormControlLabel
                            control={<Checkbox />}
                            name="declare_two"
                            value={declareValue?.second}
                            onChange={(e) => {
                              setDeclareValue((prev) => ({
                                ...prev,
                                second: !declareValue.second,
                              }));
                            }}
                            // label="I hereby declare that I have carefully read all the eligibility conditions mentioned in the advertisement and the above mentioned information in this application form. I accept and complete those requirements."
                            className="personal-information--checkbox"
                          />
                          <Stack direction="column" spacing={2}>
                           
                          </Stack>
                        </Stack> */}
              <p className={`${className}--subText`}>
                3.{" "}
                {/* {candidateData?.name
                              ? decrypt(candidateData?.name)
                              : "-"}{" "} */}
                I am / am not a regular employee of State
                Government / Government of India and I have
                informed the competent authority about sending my
                application, on (Date){" "}
                {fDate(
                  candidateData?.employee_organization_noc,
                  "dd/MM/yyyy"
                )}{" "}
                for providing No Objection Certificate.
                <br />
                मैं राज्य सरकार/भारत सरकार का नियमित कर्मचारी हूँ/
                नहीं हूँ और मैंने अपना आवेदन पत्र भेजने की सूचना
                सक्षम प्राधिकारी को दिनांक{" "}
                {fDate(
                  candidateData?.employee_organization_noc,
                  "dd/MM/yyyy"
                )}{" "}
                को विधिवत अनापत्ति प्रमाण पत्र प्रदान करने के लिए
                प्रस्तुत कर दी है।
              </p>
            </Grid>
          )}
      </Grid>
    </fieldset>
  )
}

export default Declaration;